import PaywallPlanCard from "@components/paywall/PaywallPlanCard"
import SubscriptionForm from "@components/SubscriptionForm"
import SubscriptionTerms from "@components/SubscriptionTerms"
import { ShieldCheckIcon } from "@heroicons/react/24/outline"
import { PlanPrices } from "@loaders/getPricesLoader"
import { useTranslation } from "react-i18next"
import { Plan } from "src/types"

interface Props {
  currency: string
  isSubmitting: boolean
  onPlanChange: (plan: Plan) => void
  plans: Plan[]
  popularPlan: Plan
  prices: Record<Plan, PlanPrices>
  selectedPlan: Plan
  setIsSubmitting: (isSubmitting: boolean) => void
}

const PAYMENT_METHODS = ["VISA", "Mastercard", "AMEX", "Apple Pay", "G Pay"]

export default function PaywallPlans({
  currency,
  isSubmitting,
  onPlanChange,
  plans,
  popularPlan,
  prices,
  selectedPlan,
  setIsSubmitting,
}: Props) {
  const { t } = useTranslation()

  return (
    <div className="vm-card space-y-4 p-3">
      <h2 className="vm-heading pt-2">
        {t("pages.checkout.paywall.choosePlan")}
      </h2>

      <div className="space-y-3">
        {plans.map((plan, index) => (
          <PaywallPlanCard
            animationDelayMs={index * 90}
            currency={currency}
            isPopular={plan === popularPlan}
            isSelected={plan === selectedPlan}
            key={plan}
            onSelect={() => onPlanChange(plan)}
            plan={plan}
            prices={prices[plan]}
          />
        ))}
      </div>

      <SubscriptionForm
        buttonClassName="animate-pulse-cta"
        buttonTitle={t("pages.checkout.paywall.getMyPlan")}
        currency={currency}
        isSubmitting={isSubmitting}
        plan={selectedPlan}
        setIsSubmitting={setIsSubmitting}
        stripeFullPrice={prices[selectedPlan].full}
        stripeIntroPrice={prices[selectedPlan].intro}
      />

      <div className="flex flex-col items-center gap-3">
        <div className="flex flex-wrap justify-center gap-1">
          {PAYMENT_METHODS.map((method) => (
            <span
              className="whitespace-nowrap rounded border border-vm-line bg-vm-surface px-1.5 py-0.5 text-[9px] font-bold text-vm-muted"
              key={method}
            >
              {method}
            </span>
          ))}
        </div>
        <p className="flex items-center gap-1.5 rounded-lg bg-vm-green-soft px-3 py-1.5 text-sm font-medium text-vm-green-text">
          <ShieldCheckIcon className="h-4 w-4" />
          {t("pages.checkout.paywall.paySafe")}
        </p>
        <p className="text-center text-xs text-vm-muted">
          {t("pages.checkout.paywall.guaranteeShort")}
        </p>
      </div>

      <SubscriptionTerms
        className="rounded-card text-xs text-vm-muted"
        currency={currency}
        plan={selectedPlan}
        stripeFullPrice={prices[selectedPlan].full}
        stripeIntroPrice={prices[selectedPlan].intro}
      />
    </div>
  )
}
